import { queryOptions } from '@tanstack/react-query'
import { Pagination } from '@thinknimble/tn-models'
import { createVendorBankAccountApi } from './api'
import { VendorBankAccountFilter } from './models'

export const vendorBankAccountQueries = {
  all: (vendorId: string) => ['vendor-bank-accounts', vendorId],

  list: ({
    vendorId,
    filters,
    pagination,
    paginationCallback,
  }: {
    vendorId: string
    filters?: Partial<VendorBankAccountFilter>
    pagination?: Pagination
    paginationCallback?: (pagination: Pagination) => void
  }) => {
    return queryOptions({
      queryKey: [...vendorBankAccountQueries.all(vendorId), { filters, pagination }],
      queryFn: async () => {
        const api = createVendorBankAccountApi(vendorId)
        const res = await api.list({ filters, pagination })
        const serverPagination = new Pagination({ ...res, totalCount: res.count })
        paginationCallback?.(serverPagination)
        return res
      },
      enabled: Boolean(vendorId),
    })
  },

  retrieve: (vendorId: string, id: string) => {
    return queryOptions({
      queryKey: [...vendorBankAccountQueries.all(vendorId), id],
      queryFn: () => {
        const api = createVendorBankAccountApi(vendorId)
        return api.retrieve(id)
      },
      enabled: Boolean(vendorId) && Boolean(id),
    })
  },
}
